export default {"src":"/_next/static/image/public/images/ic_flash.159a7ce5594cb94e5360abcbb6b1cd78.svg","height":20,"width":50};